export enum ContextType {
  GENERIC = 'generic',
  ROOM = 'room',
  ATTACK_BOX = 'attack_box',
  HIBRID = 'hibrid',
}

export enum GroupOperatorType {
  AND = 'and',
  OR = 'or',
}

export enum OperatorType {
  LESS_THAN = '<',
  LESS_THAN_OR_EQUALS = '<=',
  EQUALS = '==',
  GREATER_THAN = '>',
  GREATER_THAN_OR_EQUAL = '>=',
  NOT_EQUAL = '!=',
  CONTAINS = 'contains',
  NOT_CONTAINS = 'not_contains',
  STARTS_WITH = 'starts_with',
  ENDS_WITH = 'ends_with',
  REGEX = 'regex',
  ANY = 'any',
  ALL = 'all',
}

export enum FrequencyType {
  EVENTS = 'events',
  SECONDS = 'seconds',
  MINUTES = 'minutes',
  HOURS = 'hours',
}
